import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { OroService } from '../oroservice';
import { TranslateService } from '@ngx-translate/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    standalone: false
})
export class DocumentsComponent implements OnInit {
    dokumenteColumns: string[] = ['Markiert', 'Art', 'Seiten', 'Datum', 'Dossier', 'Dokument'];

    dokumente: Array<any> = [];
    select: Array<any> = []; //any[] = [];
    search: any = {
        Art: 0,
        Gelesen: 0
    };
    downloadlink: string = '#';
    update: boolean = false;

    @ViewChild(MatPaginator) paginator: MatPaginator;

    pdfSrc: string = '../../assets/img/TEST.pdf';
    allselected = false;
    dataSource = new MatTableDataSource();
    oldPageSize: number = 10;

    constructor(public oroservice: OroService,
        private chRef: ChangeDetectorRef,
        private _router: Router,
        public translate: TranslateService) {
    }

    ngAfterViewInit() {
        this.paginator._intl.itemsPerPageLabel = 'Einträge pro Seite';
        this.dataSource.paginator = this.paginator;
        this.oldPageSize = this.paginator.pageSize;
    }

    ngOnInit() {
        this.update = true;

        this.refresh();
        this.oroservice.getKundenInfo();
        this.oroservice.getDokumente().then((object) => {
            this.dokumente = object;
            this.update = false;
            this.dataSource = new MatTableDataSource<any>(this.dokumente);
            this.dataSource.paginator = this.paginator;
        });
    }

    refresh() {
        if (!this.oroservice.isEmptyObject(this.search)) {
            this.searchCick();
        } else {
            this.update = true;
            this.oroservice.getDokumente().then((object) => {
                if (!this.oroservice.isEmptyObject(object)) {
                    this.dokumente = object as Array<any>;
                    this.unselectall();
                }
                else {
                    this.dokumente = [];
                }

                this.dataSource = new MatTableDataSource<any>(this.dokumente);
                this.dataSource.paginator = this.paginator;
                this.update = false;
            });
        }
    }

    searchCick() {
        if (this.search == null || this.update) return;
        this.update = true;
        this.oroservice.setSearchDokumente(this.search).then((object) => {
            if (!this.oroservice.isEmptyObject(object)) {
                this.dokumente = object as Array<any>;
                this.unselectall();
            }
            else {
                this.dokumente = [];
            }

            this.dataSource = new MatTableDataSource<any>(this.dokumente);
                this.dataSource.paginator = this.paginator;
            this.update = false;
        });
    }

    open(doc: any) {
        doc.Gelesen = true;
    }


    unselectall() {
        (this.dokumente as Array<any>).forEach(dok => dok.Selected = false);
        //this.allselected = false;;
    }

    selectall() {
        (this.dokumente as Array<any>).forEach(dok => dok.Selected = true);
        //this.allselected = true;
    }

    switchselectall() {
        if (this.allselected) {
            this.selectall();
        } else {
            this.unselectall();
        }
    }

    downloadSelected() {
        if (this.dokumente.filter(dok => dok.Selected == true).length < 1) return;
        this.oroservice.getDokumentZip(this.dokumente.filter(dok => dok.Selected == true)).then(
            (url) => {
                this.downloadlink = url;
                this.unselectall();
            }
        );
    }

    setRead(current: any = null) {
        if (current == null) {
            this.oroservice.setDokumentRead(this.dokumente.filter(dok => dok.Selected == true)).then(
                (object) => { this.refresh(); }
            );
        } else {
            this.select = [];
            current.Selected = true;
            this.select.push(current);
            this.oroservice.setDokumentRead(this.select).then(
                (object) => { this.refresh(); }
            );
        }
    }

    public OpenDoc(dok: any, art: string): void {
        var title = this.translate.instant(art);
        this.oroservice.OpenDocument(dok.Id, title);
        this.refresh();
    }

    updateValidator() {
        if (this.oldPageSize != this.paginator.pageSize) {
            this.paginator.firstPage();
        }
        
        this.oldPageSize = this.paginator.pageSize;
    }

    public dossiernummerToString(id: number): string
    {
        if (id <= 0) {
            return "";
        } else {
            return "" + id;
        }
    }
}
